export function bindTurboBeforeCacheEvents() {
  document.addEventListener('turbo:before-cache', () => {
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
  });
}

export function bindTurboBeforeVisitEvents() {
  document.addEventListener('turbo:before-visit', () => {
    document.documentElement.style.scrollBehavior = 'auto';
  });
}

export function bindTurboLoadEvents() {
  document.addEventListener('turbo:load', () => {
    document.documentElement.style.scrollBehavior = null;

    if (window.fathom) window.fathom.trackPageview();

    const nextEl = document.getElementById('next');
    if (nextEl) nextEl.scrollIntoView({ behavior: 'smooth' });
  });
}
